export default __webpack_public_path__ + "static/sm-645d391052b195f495445a27f34c283e.jpg";